// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import ReactGA from "react-ga4";
import imgNoResultsDark from '../../img/dark-theme/empty-state.svg'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postShareInstallation = endpointHelias+"/Helias/V0/Configuration/postShareInstallation"

var initialConfigCommonJS = require("../../js/initialConfigCommon.js");
var generalCommonJS = require("../../js/generalCommon.js")

const InstallersList = (params) => {    

  useEffect(() => {                 
    console.log("Componente listado de instaladores cargado correctamente.")      
  }, [params]);

  function compartirConInstalador(idInstalador){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    
    document.getElementById("loaderShareInstallation").className = "loader overlay"
    
    //Petición de datos para el paso actual
    var jsonPeticion = {
      "installationID": localStorage.getItem("installationId"),
      "accountID": localStorage.getItem("accountID"),
      "installerID": idInstalador
    }
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
    xhttp.open("POST", postShareInstallation, true);        
    xhttp.setRequestHeader('Content-Type', "application/json");
    xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
    var data = JSON.stringify(jsonPeticion);
    xhttp.onreadystatechange = function() {
      
      if (this.readyState === 4 && this.status === 200) {
        var jsonRespuesta = JSON.parse(this.responseText)
        if(jsonRespuesta.statusCode === "403"){                   
          initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
        }
        else{    
          
          document.getElementById("loaderShareInstallation").className = "loader hidden"          
          params.seleccionarOpcionSharing("verEstadoComparticion")

          document.getElementById("textoBuscador").value = ""
          document.getElementById("resultadoBusqueda").className += " hidden"


          initialConfigCommonJS.mostrarMensajeInformativo('Instalación compartida correctamente.',"positive")

          generalCommonJS.registrarEventoAnalitica(ReactGA, 'CONFIGURACIÓN', 'COMPARTIR - Con instalador', "", "")          

          console.log("Información cargada correctamente")
        }
      }
  
      if (this.readyState === 4 && this.status !== 200) {  
        document.getElementById("loaderShareInstallation").className = "loader hidden"
        initialConfigCommonJS.mostrarMensajeInformativo('Se produjo un error al cargar la configuracion.',"negative")
        initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
      }
    }
    xhttp.send(data);      

  }

  const listInstallers = params.listadoInstaladores.map((installer, index) =>
    
    <React.Fragment key={installer.INSTALLATION_ID}>
    
    <details id="idAcordeonInstalador" className="accordion">
    
      <summary className="title">
        <figure className="avatar size-xl pink"><span className="material-icon">business</span></figure>                          
        <div className="content vertical">          
          <span className="size-l">{installer.InstallerName}</span>              
          <span className="size-m">{installer.GeneralInfo.InstallationAddress} - {installer.GeneralInfo.InstallationLocationName}</span>
        </div>
      </summary>

      <div className="accordion-content vertical gap-06">
        <ul className="columns col-sm-2 gap-04">
          <li className="horizontal gap-03 center cyan break">
            <figure className="avatar size-l"><span className="material-icon">person</span></figure>            
            <span className="fill">{installer.GeneralInfo.InstallationContact}</span>   
          </li>
          <li>
            <a href={"tel://"+installer.GeneralInfo.InstallationPhoneNumber.replaceAll(" ","")} className="horizontal gap-03 center cyan break">
              <figure className="avatar size-l"><span className="material-icon">call</span></figure>            
              <span className="fill">{installer.GeneralInfo.InstallationPhoneNumber}</span>                 
            </a>
          </li>
          <li>
            <a href={"mailto:"+installer.GeneralInfo.InstallationEmail} className="horizontal gap-03 center cyan break">
              <figure className="avatar size-l"><span className="material-icon">email</span></figure>            
              <span className="fill">{installer.GeneralInfo.InstallationEmail}</span>        
            </a>
          </li>
        </ul>

        { localStorage.getItem("currentSharingStatus").includes(installer.INSTALLATION_ID) ?
          <button className="button primary full-width" disabled>
            Ya tienes compartida tu instalación con esta empresa
          </button>
        :
          <button className="button primary full-width" onClick={() => compartirConInstalador(installer.INSTALLATION_ID)}>
            Compartir con esta empresa
          </button>
        }
        

      </div>

    </details>
    </React.Fragment>
  );    

  return (      
    <>
      { params.listadoInstaladores.length > 0 ?
        [listInstallers]
        :
        <div id="divSinResultadosInstaladores" className="message medium empty">
          <picture>
            <source srcSet={imgNoResultsDark} media="(prefers-color-scheme: dark)"/>
            <img src={imgNoResultsDark} alt=""/>
          </picture>
          <h1 className="title">No he encontrado instaladores con ese nombre o similares</h1>
        </div>
      }
    </>  
    )
  }

export default InstallersList